import React from 'react';
import { Label } from '../../ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/select';
import { Palmtree } from 'lucide-react';

const PaidLeaveFields = ({ formData, setFormData }) => {
  return (
    <div className="space-y-4 p-4 bg-purple-500/5 rounded-lg border border-purple-500/20">
      <div className="flex items-center gap-2 mb-2">
        <Palmtree className="h-4 w-4 text-purple-400" />
        <h3 className="text-sm font-medium text-purple-400">Paid Leave Details</h3>
      </div>

      <div className="space-y-2">
        <Label className="text-slate-300">Leave Type</Label>
        <Select
          value={formData.leave_type}
          onValueChange={(value) => setFormData({ ...formData, leave_type: value })}
        >
          <SelectTrigger className="bg-slate-900 border-slate-600 text-white" data-testid="paid-leave-type-select">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="bg-slate-800 border-slate-600">
            <SelectItem value="annual_leave" className="text-white hover:bg-slate-700">Annual Leave</SelectItem>
            <SelectItem value="sick_leave" className="text-white hover:bg-slate-700">Sick Leave</SelectItem>
            <SelectItem value="other" className="text-white hover:bg-slate-700">Other</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default PaidLeaveFields;
